<template>
  <!-- P云 banner广告组件 -->
  <div class="adBox pyun-banner-ad" :id="containerId"></div>
</template>
<script>
import { loadPyunSdk, getPyunInstance } from '../../api/pyunSdk'
import { pyunAppId, pyunProviderUrl, pyunExternal } from '../../../config/pyunConfig'
import { logger } from '../../api/pyunLogger'

let adCounter = 0

export default {
  name: 'ad_pcloud',
  props: {
    spaceId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      containerId: 'pyun-banner-' + (++adCounter)
    }
  },
  methods: {
    async loadAd () {
      try {
        const sid = this.$store.state.sid.sid
        logger.info('[PyunBanner] 开始加载广告, spaceId:', this.spaceId, 'provider_code:', sid, 'el:', this.containerId)

        await loadPyunSdk()
        const pyun = getPyunInstance()
        if (!pyun || typeof pyun.advertingPull !== 'function') {
          logger.error('[PyunBanner] SDK未加载')
          return
        }

        pyun.advertingPull({
          el: this.containerId,
          app_id: pyunAppId,
          openid: this.$store.getters.openID || '',
          space_id: this.spaceId,
          displayed: 1,
          provider_code: sid || '',
          external: pyunExternal,
          provider_url: pyunProviderUrl,
          personas: {},
          success: function (data) {
            logger.info('[PyunBanner] 广告加载成功', data)
          },
          failure: function (cause) {
            logger.error('[PyunBanner] 广告加载失败', cause)
          }
        })
      } catch (err) {
        logger.error('[PyunBanner] 加载异常', err)
      }
    }
  },
  mounted () {
    if (this.spaceId) {
      this.loadAd()
    } else {
      logger.warn('[PyunBanner] spaceId为空，跳过加载')
    }
  }
}
</script>

<style scoped>
.adBox {
  width: 100%;
  height: 100%;
}
</style>
